
import { UploadedFiles } from "@portal/BaseComponents/Document/UplodedFiles/UploadedFiles";
import { Icon } from "@portal/lib/icons/icons";
import { DocumentList } from "@portal/types/entities/documents";
import { FileType, PreviewFiles } from "@portal/types/file";
import {
  getFileExtensionFromName,
  getFileTypeFromExtension,
} from "@portal/util/file";

const PreviewIcon = (
  <Icon
    icon={['far','file-magnifying-glass']}
    fontSize={18}
    color="var(--primary-7)"
  />
);
function Preview(props: Pick<DocumentList, "attachment">) {
  const { attachment } = props;
  const fileExtension = getFileExtensionFromName(attachment.file_name);
  const fileType = fileExtension
    ? getFileTypeFromExtension(fileExtension)
    : FileType.PDF;

  const isPreviewFile = !PreviewFiles.includes(fileType);
  const Preview = (
    <UploadedFiles
      file={attachment}
      previewType="EXPIRE_LINK"
      previewIcon={PreviewIcon}
      previewMode="BUTTON"
      hide={isPreviewFile}
    />
  );
  return <>{Preview}</>;
}

export { Preview };
